import { createApp } from "vue";
import App from "./App.vue";
import mitt from "mitt";
import { store } from "./util/store";
import { validations } from "./util/validationRules";

const emitter = mitt();

const app = createApp(App);

app.config.globalProperties.emitter = emitter;
app.config.globalProperties.store = store;
app.config.globalProperties.validations = validations;
app.config.globalProperties.merges = window.newMemberAppMerges ?? {};

app.mount("#app");
